
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "MarketingInfo"
})
export default class MarketingInfo extends Vue {}
